//components
import {CancelConfirmPanel} from 'thrive-components';
import ModalWrapper from  '@/components/modals/ModalWrapper';

//styling
import "../../../../css/global/Modals/passkey-data-modal.scss";



const RemoveIpAddressModal = ({showModal, hideModal, onConfirmClick} : {showModal: boolean, hideModal: () => void, onConfirmClick: ()=>void}) => {
    return (
        <>
        <ModalWrapper 
            isOpen={showModal} 
            onRequestClose={hideModal} 
            className="remove-ip-address-modal" 
            isFullPage
        >
                <div className="remove-ip-address-modal-content">
                     <h1 className='header-text'>Remove IP Address</h1> 
            
                    <div>
                        This IP will no longer be allowed for account recovery or sign-in codes. Remove it?
                    </div>
                                
                    <CancelConfirmPanel 
                        panelClassName={'remove-ip-button-panel'}
                        cancelContent={'Cancel'} 
                        confirmContent={'Confirm'} 
                        ariaLabelCancel={'Cancel and close modal'} 
                        ariaLabelConfirm={'Confirm and remove IP address'} 
                        onCancelClick={hideModal}
                        onConfirmClick={onConfirmClick}
                    />
                </div>
        </ModalWrapper> 
        </>
    );  
}

export default RemoveIpAddressModal;
